import React from 'react';
import cfg from '../config';

/* Ganzseitiger Hinweis, wenn der Zugang gesperrt ist — entweder weil die
   Lizenz ungültig oder abgelaufen ist, oder weil ein Administrator die
   Notsperre gesetzt hat. Wird anstelle des Login-Formulars angezeigt. */

const TEXTE = {
    expired: {
        icon:  '⏳',
        farbe: '#f0a500',
        titel: 'Lizenz abgelaufen',
        text:  'Die Nutzungslizenz für diese Anwendung ist abgelaufen. Bis zur Verlängerung ist keine Anmeldung möglich.',
    },
    invalid: {
        icon:  '⚠️',
        farbe: '#f87171',
        titel: 'Lizenz ungültig',
        text:  'Die hinterlegte Lizenz konnte nicht überprüft werden. Bitte wende dich an den Hersteller.',
    },
    missing: {
        icon:  '🔑',
        farbe: '#f87171',
        titel: 'Keine Lizenz hinterlegt',
        text:  'Für diese Anwendung ist keine gültige Lizenz konfiguriert. Eine Anmeldung ist deshalb nicht möglich.',
    },
    locked: {
        icon:  '🔒',
        farbe: '#9aa0a6',
        titel: 'Zugang gesperrt',
        text:  'Der Zugang zu dieser Anwendung wurde vorübergehend gesperrt.',
    },
};

const LicenseBlocked = ({ status, expDate, customer, systemLocked, lockedMessage }) => {
    const art = systemLocked ? TEXTE.locked : (TEXTE[status] || TEXTE.invalid);
    const kontakt = cfg.vendorEmail;

    return (
        <div style={{
            minHeight: '100vh',
            display: 'grid',
            placeItems: 'center',
            padding: '1.5rem',
            background: 'radial-gradient(1200px 600px at 50% -10%, #1f2430 0%, #121418 60%)',
        }}>
            <div style={{
                width: '100%',
                maxWidth: 470,
                background: '#1b1e24',
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: 18,
                padding: '2.2rem 1.8rem',
                textAlign: 'center',
                boxShadow: '0 24px 60px rgba(0,0,0,0.45)',
            }}>
                <div style={{
                    width: 68, height: 68, margin: '0 auto 1.1rem',
                    borderRadius: 20, display: 'grid', placeItems: 'center',
                    fontSize: '2rem', background: `${art.farbe}1a`,
                    border: `1px solid ${art.farbe}40`,
                }}>
                    {art.icon}
                </div>

                <h1 style={{ fontSize: '1.35rem', fontWeight: 650, color: '#f2f3f5', margin: '0 0 0.6rem' }}>
                    {art.titel}
                </h1>

                <p style={{ color: '#a2a8ae', fontSize: '0.94rem', lineHeight: 1.65, margin: '0 0 1.3rem' }}>
                    {systemLocked && lockedMessage ? lockedMessage : art.text}
                </p>

                {!systemLocked && (customer || expDate) && (
                    <div style={{
                        background: 'rgba(255,255,255,0.03)',
                        border: '1px solid rgba(255,255,255,0.07)',
                        borderRadius: 11,
                        padding: '0.75rem 1rem',
                        marginBottom: '1.3rem',
                        fontSize: '0.85rem',
                        color: '#9aa0a6',
                        textAlign: 'left',
                    }}>
                        {customer && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                                <span>Lizenznehmer</span><span style={{ color: '#d6d9dc' }}>{customer}</span>
                            </div>
                        )}
                        {expDate && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', marginTop: 4 }}>
                                <span>{status === 'expired' ? 'Abgelaufen am' : 'Gültig bis'}</span>
                                <span style={{ color: '#d6d9dc' }}>{expDate}</span>
                            </div>
                        )}
                    </div>
                )}

                {kontakt && (
                    <>
                        <p style={{ color: '#7c8186', fontSize: '0.84rem', margin: '0 0 0.5rem' }}>
                            Ansprechpartner
                        </p>
                        <a href={`mailto:${kontakt}`} style={{
                            display: 'inline-block',
                            background: 'rgba(240,165,0,0.1)',
                            border: '1px solid rgba(240,165,0,0.35)',
                            color: '#ffcb57',
                            borderRadius: 10,
                            padding: '0.55rem 1.4rem',
                            fontWeight: 600,
                            fontSize: '0.92rem',
                            textDecoration: 'none',
                            userSelect: 'all',
                        }}>
                            {kontakt}
                        </a>
                    </>
                )}

                <div style={{ marginTop: '1.6rem' }}>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            background: 'none', border: 'none',
                            color: 'rgba(255,255,255,0.28)',
                            fontSize: '0.8rem', cursor: 'pointer',
                        }}
                    >
                        Erneut versuchen
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LicenseBlocked;
